import React from 'react';
import { X, Building2, Palette } from 'lucide-react';

const ProfileModal = ({
    isOpen,
    onClose,
    isEditing,
    setIsEditing,
    editData,
    setEditData,
    handleSaveProfile,
    updateLoading,
    userData,
    user,
    tenantData,
    displayName,
    userInitials,
    t,
    navigate
}) => {
    if (!isOpen) return null;

    return (
        <div className="profile-modal-overlay" onClick={onClose}>
            <style>{`
                @media (max-width: 600px) {
                    .profile-modal-grid-2 { grid-template-columns: 1fr !important; }
                }
            `}</style>
            <div className="profile-modal" onClick={e => e.stopPropagation()}>
                <button
                    onClick={onClose}
                    style={{ position: 'absolute', top: '20px', right: '20px', background: 'transparent', border: 'none', cursor: 'pointer', color: 'var(--text-muted)' }}
                >
                    <X size={24} />
                </button>

                <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                    <div style={{
                        width: '80px', height: '80px', borderRadius: '50%', background: 'var(--primary)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white',
                        fontSize: '2rem', fontWeight: 800, margin: '0 auto 1rem',
                        boxShadow: '0 8px 16px rgba(var(--primary-rgb), 0.2)'
                    }}>
                        {userInitials}
                    </div>
                    <h2 style={{ fontSize: '1.5rem', fontWeight: 800 }}>{isEditing ? 'Profili Düzenle' : displayName}</h2>
                    <p style={{ color: 'var(--text-muted)' }}>{userData?.position || userData?.role}</p>
                </div>

                {isEditing ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                        <div className="profile-modal-grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                            <div className="profile-item">
                                <label className="profile-label">Ad</label>
                                <input
                                    className="edit-input"
                                    value={editData.firstName}
                                    onChange={e => setEditData({ ...editData, firstName: e.target.value })}
                                />
                            </div>
                            <div className="profile-item">
                                <label className="profile-label">Soyad</label>
                                <input
                                    className="edit-input"
                                    value={editData.lastName}
                                    onChange={e => setEditData({ ...editData, lastName: e.target.value })}
                                />
                            </div>
                        </div>

                        <div className="profile-item">
                            <label className="profile-label">Telefon</label>
                            <input
                                className="edit-input"
                                value={editData.phone}
                                onChange={e => setEditData({ ...editData, phone: e.target.value })}
                            />
                        </div>

                        <div style={{ borderTop: '1px solid var(--border)', paddingTop: '1.25rem' }}>
                            <h3 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '1rem' }}>İşletme Bilgileri</h3>
                            <div className="profile-item">
                                <label className="profile-label">İşletme Adı</label>
                                <input
                                    className="edit-input"
                                    value={editData.businessName}
                                    onChange={e => setEditData({ ...editData, businessName: e.target.value })}
                                />
                            </div>
                            <div className="profile-item">
                                <label className="profile-label">Adres</label>
                                <textarea
                                    className="edit-input"
                                    style={{ height: '80px', resize: 'none' }}
                                    value={editData.address}
                                    onChange={e => setEditData({ ...editData, address: e.target.value })}
                                />
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: '10px', marginTop: '1rem' }}>
                            <button
                                className="btn-primary"
                                disabled={updateLoading}
                                onClick={handleSaveProfile}
                                style={{ flex: 2, padding: '12px', borderRadius: '12px', cursor: 'pointer' }}
                            >
                                {updateLoading ? 'Kaydediliyor...' : 'Değişiklikleri Kaydet'}
                            </button>
                            <button
                                className="btn-secondary"
                                disabled={updateLoading}
                                onClick={() => setIsEditing(false)}
                                style={{ flex: 1, padding: '12px', borderRadius: '12px', background: 'var(--bg-main)', border: '1px solid var(--border)', color: 'var(--text-main)', cursor: 'pointer' }}
                            >
                                İptal
                            </button>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="profile-modal-grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                            <div className="profile-item">
                                <span className="profile-label">{t('common.email')}</span>
                                <span className="profile-value" style={{ wordBreak: 'break-all' }}>{userData?.email || user?.email}</span>
                            </div>
                            <div className="profile-item">
                                <span className="profile-label">{t('setup.phone')}</span>
                                <span className="profile-value">{userData?.phone || tenantData?.phone || 'N/A'}</span>
                            </div>
                        </div>

                        <div style={{ borderTop: '1px solid var(--border)', marginTop: '0.5rem', paddingTop: '1.5rem' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '1.5rem' }}>
                                <Building2 size={20} style={{ color: 'var(--primary)' }} />
                                <h3 style={{ fontSize: '1.125rem', fontWeight: 700 }}>İşletme Bilgileri</h3>
                            </div>

                            <div className="profile-item">
                                <span className="profile-label">İşletme Adı</span>
                                <span className="profile-value">{tenantData?.name}</span>
                            </div>

                            <div className="profile-item">
                                <span className="profile-label">Adres</span>
                                <span className="profile-value" style={{ fontSize: '0.875rem', fontWeight: 500 }}>{tenantData?.address || 'N/A'}</span>
                            </div>

                            <div className="profile-item" style={{ marginBottom: 0 }}>
                                <span className="profile-label">Sektör</span>
                                <span className="profile-value" style={{ textTransform: 'capitalize' }}>{tenantData?.industry || 'N/A'}</span>
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: '10px', marginTop: '2rem' }}>
                            <button
                                className="btn-primary"
                                onClick={() => setIsEditing(true)}
                                style={{ flex: 1, padding: '12px', borderRadius: '12px', cursor: 'pointer' }}
                            >
                                Bilgileri Düzenle
                            </button>
                            <button
                                className="btn-secondary"
                                onClick={() => { onClose(); navigate('/app/settings'); }}
                                style={{ padding: '12px', borderRadius: '12px', background: 'var(--bg-main)', border: '1px solid var(--border)', color: 'var(--text-main)', cursor: 'pointer' }}
                            >
                                <Palette size={20} />
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ProfileModal;
